/**
 * SVG color-blindness filters injected once into the document.
 * Matrices from Machado et al. (2009) simulation models.
 */
export const COLOR_BLIND_SVG_ID = "a11y-cb-filters";

export function ensureColorBlindFilters() {
  if (typeof document === "undefined") return;
  if (document.getElementById(COLOR_BLIND_SVG_ID)) return;

  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("id", COLOR_BLIND_SVG_ID);
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("style", "position:absolute;width:0;height:0;overflow:hidden");

  svg.innerHTML = `
    <defs>
      <filter id="a11y-protanopia"><feColorMatrix type="matrix" values="
        0.567 0.433 0     0 0
        0.558 0.442 0     0 0
        0     0.242 0.758 0 0
        0     0     0     1 0"/></filter>
      <filter id="a11y-deuteranopia"><feColorMatrix type="matrix" values="
        0.625 0.375 0   0 0
        0.7   0.3   0   0 0
        0     0.3   0.7 0 0
        0     0     0   1 0"/></filter>
      <filter id="a11y-tritanopia"><feColorMatrix type="matrix" values="
        0.95  0.05  0     0 0
        0     0.433 0.567 0 0
        0     0.475 0.525 0 0
        0     0     0     1 0"/></filter>
      <filter id="a11y-achromatopsia"><feColorMatrix type="matrix" values="
        0.299 0.587 0.114 0 0
        0.299 0.587 0.114 0 0
        0.299 0.587 0.114 0 0
        0     0     0     1 0"/></filter>
    </defs>
  `;
  document.body.appendChild(svg);
}
